<template>
  <v-card :loading="loading">
    <div class="card-body">
      <div class="col-md-6 mx-auto">
        <v-text-field label="کدملی"
                      v-model="code"
                      outlined
                      dense/>

        <v-btn :loading="loading" @click="getData">
          دریافت اطلاعات
        </v-btn>

        <div v-if="user.name">
          <hr>
          <p>
            <strong>نام:</strong>
            {{user.name}}
          </p>
          <p>
            <strong>نام‌خانوادگی:</strong>
            {{user.family}}
          </p>
          <p>
            <strong>جنسیت:</strong>
            {{user.gender==='men' ? 'مرد' : 'زن'}}
          </p>
          <p>
            <strong>تاریخ تولد:</strong>
            {{user.birth_date}}
          </p>
          <p>
            <strong>نام پدر:</strong>
            {{user.father_name}}
          </p>
        </div>


      </div>
    </div>
  </v-card>
</template>
<script>

import {Axios2} from "@/main";

export default {
  name: "PersonInfo",
  data() {
    return {
      loading: false,
      code: '',
      user: {}
    }
  },
  methods: {
    getData() {
      if (!this.code)
        return;

      this.loading = true;

      Axios2.get('/person/info?code='+this.code)
          .then(res => this.user = res.data)
          .catch(console.log)
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>
</style>